package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initRequest_failed_with_status_code_504Page(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/request_failed_with_status_code_504.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/request-failed-with-status-code-504")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Request_failed_with_status_code_504Page() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("request-failed-with-status-code-504") }) {
        org.jetbrains.compose.web.dom.Text("Request failed with status code 504")
    }
    com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figure") {
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("img", attrs = {attr("src", "../.gitbook/assets/image.png");attr("alt", "")})
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("figcaption")
    }

    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The error ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("“Request failed with status code 504”")
        }
        org.jetbrains.compose.web.dom.Text(" indicates that the server took too long to respond to your request. This usually happens when the node is temporarily overloaded or experiencing high traffic.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In most cases, this is a short-term issue and does not require any action on your part.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("What you can do:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Wait a few minutes and try again")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If the issue persists for an extended period, check out the status-updates channel.")
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("If no issue is reported about that, feel free to contact support for further assistance.")
    }
}
